import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchCart } from "../../../_actions/cart.actions";

export const CartPreview = (props) => {
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  useEffect(() => {
    dispatch(fetchCart());
  }, []);
  return (
    <Link to="/dashboard/cart">
      <div
        className={`cart-preview-container ${
          cartItems.length > 0 ? "active" : ""
        }`}
      >
        <div className="cart-preview"></div>
        <div className="cart-num">{cartItems.length}</div>
      </div>
    </Link>
  );
};